export const WELL_OVERVIEW_ACTIONS = {
  UPLOAD_WELLBORE_TRAJECTORY: 'UPLOAD_WELLBORE_TRAJECTORY',
  GET_WELLBORE_TRAJECTORY_PREVIEW: 'GET_WELLBORE_TRAJECTORY_PREVIEW',
  GET_WELLCOM_TRAJECTORY_SURVEY: 'GET_WELLCOM_TRAJECTORY_SURVEY',
  DOWNLOAD_TRAJECTORY_TEAMPLTE_TXT: 'DOWNLOAD_TRAJECTORY_TEAMPLTE_TXT',
  DOWNLOAD_TRAJECTORY_TEAMPLTE_CSV: 'DOWNLOAD_TRAJECTORY_TEAMPLTE_CSV',
  DOWNLOAD_TRAJECTORY_SURVEY_TXT: 'DOWNLOAD_TRAJECTORY_SURVEY_TXT',
  DOWNLOAD_TRAJECTORY_SURVEY_CSV: 'DOWNLOAD_TRAJECTORY_SURVEY_CSV',
};
